import { debounce } from 'lodash-es';
import BaseView from '../../../js/base-view';

const SELECTOR_INPUT = '.search-header__input';
const SELECTOR_CROSS = '.search-header__clear';

const DEBOUNCE_DELAY = 500;

export default class SearchForm extends BaseView {
	init() {
		this.refs = {
			inputSearch: this.el.querySelector(SELECTOR_INPUT),
			cross: this.el.querySelector(SELECTOR_CROSS),
		};

		this.toggleClearHandler = debounce(this.toggleClear, DEBOUNCE_DELAY, { leading: true });

		// attach events
		this.bindEvents();

		// Init state
		this.toggleClear();
	}

	/**
	 * Bind component's events
	 */
	bindEvents() {
		this.on('keyup', SELECTOR_INPUT, this.toggleClearHandler.bind(this));
		this.on('click', SELECTOR_CROSS, this.clearInput.bind(this));
	}

	toggleClear() {
		this.refs.cross.setAttribute('aria-hidden', (this.refs.inputSearch.value === ''));
	}

	clearInput() {
		this.refs.inputSearch.value = '';
		this.refs.inputSearch.focus();
		this.toggleClear();
	}
}
